import React, {useContext, useEffect, useRef, useState} from 'react';
import { Field } from 'react-final-form';
import Grid from "@material-ui/core/Grid";
import { Trans } from "../utils/i18n";
import {hasProducts} from "../config/orderEntryEnfore";
import {useFormState, useFormStateDispatch} from "../FormComponents/FormState";
import {Button, IconButton, Modal} from "@mui/material";
import {InputLabel, Typography} from "@material-ui/core";
import styled from "styled-components";
import RadioButton from "./RadioBig";
import FormControl from "@material-ui/core/FormControl";
import DeleteIcon from "@material-ui/icons/Delete";
import CloseIcon from "@material-ui/icons/Close";
import Select from "./Select";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import MuiButton from "@material-ui/core/Button";
import { useGetProductCategories } from '../hooks/useOrderProductCategories';

export const ProductSelectManual = React.memo(function ({ values, form, productValues, nextStep, }) {
        const orderEntryDispatch = useFormStateDispatch();
        const { categories, selectedCategory, serialNumber: {product, address, order, problems, accessories, openOrders, } } = useFormState();
        useGetProductCategories({}, {
            onSuccess: (response) => {
                orderEntryDispatch({
                    type: "setCategories",
                    value: response.categories,
                });
            }
        });

        if (!categories) {
            return <div><Trans i18nKey="productSelect.loading">Loading</Trans></div>;
        }

        return (
            <div>
                <div>
                    <Typography variant="h5" style={{ marginBottom: 30, fontSize: 22 }}>
                        <Trans i18nKey="orderEntry.productSelect.selectDevice">Select your Amazon device</Trans>
                    </Typography>
                    <div
                        className={'my-6 p-6 bg-white cursor-pointer rounded-lg flex justify-center items-center text-primary gap-3'}
                        style={{ boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.1)', }}
                        onClick={() => {
                            orderEntryDispatch({ type: 'setManualDeviceSelection', value: false, });
                        }}
                    >
                        <ArrowBackIcon fontSize="small" style={{ verticalAlign: 'bottom' }}/>
                        <span className={'underline'}>
                            <Trans i18nKey="orderEntry.productSelect.goBackToProposedDevice">Go back to proposed Device</Trans>
                        </span>
                    </div>
                    <div className={'grid grid-cols-10 gap-6 mt-6'}>
                        {
                            categories
                                .map((category) =>
                                    <div className={'col-span-5 md:col-span-2'} key={category.id}>
                                        <RadioButton
                                            input={{
                                                checked: selectedCategory?.id === category.id,
                                                value: category.id,
                                                onChange: (e) => {
                                                    orderEntryDispatch({ type: 'setSelectedCategory', value: category });
                                                },
                                            }}
                                            field={{
                                                titel: category.description,
                                            }}
                                            meta={{}}
                                        />
                                    </div>,
                                )
                        }
                    </div>
                    {
                        !!selectedCategory &&
                        <Typography variant="h5" style={{ marginTop: 30, fontSize: 22 }}>
                            <Trans i18nKey="orderEntry.productSelect.heading">Please select your product</Trans>
                        </Typography>
                    }
                    <div className={'grid grid-cols-10 gap-6 mt-6'}>
                        {
                            selectedCategory && selectedCategory.products.map((item) =>
                                <div className={'col-span-5 md:col-span-2'} key={item.id}>
                                    <RadioButton
                                        input={{
                                            name: 'product',
                                            type: 'radio',
                                            value: item.id,
                                            checked: item.id === product?.id,
                                            onChange: (e) => {
                                                orderEntryDispatch({ type: 'setSerialNumber', value: {product: item, address: {}, order: {}, problems: item.problems, accessories: [], openOrders: [], } });
                                            },
                                        }}
                                        field={{
                                            titel: item.description,
                                            image: item.image,
                                            // description: item.description,
                                        }}
                                        meta={{}}
                                    />
                                </div>,
                            )
                        }
                    </div>
                </div>

                {
                    product &&
                    <div>
                        <div>
                            <h2 className={'h2'}><Trans i18nKey="common.deviceConfirm">Confirm your device</Trans></h2>
                        </div>
                        <div className={'p-6 bg-white rounded-lg shadow-lg grid grid-cols-12 mt-3 gap-1'}>
                            <div className={'col-span-12 md:col-span-3'}>
                                <div className={'px-12 py-6 flex justify-center'}>
                                    {
                                        product.image && <img className={'max-w-[8rem]'} src={product.image} alt={product.description} />
                                    }
                                </div>
                                <p className={'text-md text-center hidden md:block'}>
                                    { product.description }
                                </p>
                            </div>
                            <div className={'col-span-12 md:col-span-6 flex flex-col items-start md:pl-6'}>
                                <div className={'flex-1'}>
                                    <p><span className={'font-bold'}><Trans i18nKey="common.device">Device</Trans>:</span> { product.description } </p>
                                    <p><span className={'font-bold'}><Trans i18nKey="common.version">Version</Trans>:</span> { product.description } </p>
                                    <p><span className={'font-bold'}><Trans i18nKey="common.serialNumberDNS">Serial Number (DNS)</Trans>:</span> { values.serialnumber } </p>
                                </div>
                            </div>
                            <div className={'col-span-12 md:col-span-3 flex items-end justify-end'}>
                                <MuiButton
                                    variant="contained"
                                    color={'secondary'}
                                    onClick={nextStep}
                                    id={'serialnumber-search'}
                                >
                                    <Trans i18nKey="common.continue">Continue</Trans>
                                </MuiButton>
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    },
    function areEqual(prevProps, nextProps) {
        return JSON.stringify(prevProps) === JSON.stringify(nextProps);
    });

